<template>
  <v-container fluid class="teams">
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <ImageInput ref="imageinput" @imageChange="imageChange"></ImageInput>

    <v-layout row wrap>
      <v-flex md10 offset-md1 class="mb-5">
        <span class="green--text">Equipos</span>
        <span class="ml-3 mr-3">></span>
        <span>{{ teamID ? currentTeam.name : "Nuevo Equipo"}}</span>
      </v-flex>

      <v-flex lg3 md4 xs12 offset-md1 class="mb-4">
        <h4 class="green--text headline">{{ teamID ? currentTeam.name : "Nuevo Equipo"}}</h4>
        <v-card light>
          <v-card-media class="overflow-visible pt-2 pl-2" :src="currentTeam.image" height="200px">
            <span class="headline white--text">{{ team.name }}</span>
            <v-btn
              absolute
              dark
              fab
              bottom
              right
              v-on:click="openFileChoser()"
              color="green">
              <v-icon>file_upload</v-icon>
            </v-btn>
          </v-card-media>
          <v-card-text>
            <v-form>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="currentTeam.name"
                      label="Nombre"
                      prepend-icon="star"
                      light
                      class="green--text"
                    ></v-text-field>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-layout class="text-xs-right">
              <v-spacer></v-spacer>
              <v-btn v-on:click="goBack()" flat color="red">Cancelar</v-btn>
              <v-btn v-on:click="save()" color="green">Guardar</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex lg7 md6 xs12 class="team-players-table">
          <div class="table-header">
            <h4 class="green--text headline mb-0">Jugadores</h4>
            <v-tooltip left>
              <v-btn @click="showNewPlayerDialog()"
                dark
                color="green"
                slot="activator"
                fab
                small
                :disabled="teamID == null">
                  <v-icon>add</v-icon>
              </v-btn>
              <span>Agregar nuevo jugador a este equipo</span>
            </v-tooltip>
          </div>

          <v-data-table
            :rows-per-page-items="[25,50,100]"
            :headers="headers"
            :items="currentPlayersPerTeam"
            class="elevation-1"
            light
            :loading="tableLoading"
            rows-per-page-text="Filas por página">
            <template slot="items" slot-scope="props">
              <td @click="showEditPlayerDialog(props.item)" class="text-xs-left green--text">
                <span class="cursor-pointer">{{ props.item.name }}</span>
              </td>
              <td class="text-xs-left green--text">
                <v-tooltip left>
                  <v-btn
                      @click="deletePlayer(props.item)"
                      flat
                      icon
                      light
                      slot="activator">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Eliminar jugador</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
      </v-flex>
    </v-layout>

      <confirm-modal
        :dialog="showConfirm"
        :message="confirmMessage"
        @confirm="onDeletePlayerResponse($event)">
      </confirm-modal>
      <new-player-dialog
        :dialog = "currentShowPlayerDialog"
        :player = "currentPlayer"
        :teamid = "teamID">
      </new-player-dialog>
  </v-container>

</template>
<script>
import ImageInput from '@/components/helpers/ImageInput'
import Player from '@/models/player'
import NewPlayerDialog from "./NewPlayerDialog"
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "TeamForm",
  data: () => ({
    messageLoader: 'Cargando Información...',
    team: {
      name: '',
      captain: '',
      pin: null,
      image: ''
    },
    player: new Player(),
    showPlayerDialog:false,
    showConfirm:false,
    confirmMessage:"",
    editMode : false,
    tableLoading: false,
    playerTodelete:null,
    confirmMessage: '¿Estas seguro que quieres borrar al jugador?',
    headers: [
      { text: 'Nombre', value: 'name', align: 'left' },
      { text: 'Acciones', value: 'actions', align: 'left' },
    ]
  }),
  props: ['teamID'],
  created() {
    //do something after creating vue instance
    if(this.teamID) {
      this.loadTeam(this.teamID)
      this.editMode = true
      this.loadPlayersPerTeam(this.teamID)
    }
  },
  computed:{
    ...mapGetters([
      'currentTeam',
      'currentShowPlayerDialog',
      'currentPlayer',
      'currentPlayersPerTeam'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadTeam',
      'createTeam',
      'updateTeam',
      'goBack',
      'showNewPlayerDialog',
      'showEditPlayerDialog',
      'saveNewPlayer',
      'loadPlayersPerTeam',
      'removePlayer'
    ]),
    openFileChoser() {
      this.$refs.imageinput.open()
    },
    imageChange(img,imageFile){
      this.currentTeam.image = img.src
      this.currentTeam.imageFile = imageFile
    },
    save(){
      if(this.editMode){
        this.messageLoader = 'Editando Equipo...'
        console.log(this.currentTeam)
        this.updateTeam(this.currentTeam)
      }else{
        this.messageLoader = 'Guardando Equipo...'
        this.createTeam(this.currentTeam)
      }
    },
    deletePlayer(player){
      this.playerTodelete = player
      this.showConfirm = true
    },
    onDeletePlayerResponse(response){
      this.showConfirm = false
      if(response){
        this.removePlayer(this.playerTodelete)
      }
    }

  },
  components: {
    ImageInput,
    NewPlayerDialog
  }
}
</script>
<style lang="css" scoped>
  .table-header {
    display: flex;
    margin-bottom: 7px;
  }

  .table-header .btn {
    margin: 0;
  }

  .table-header .headline {
    margin-right: auto;
  }

  .overflow-visible {
    overflow: visible !important;
  }
  .teams >>> .team-players-table {
    padding-left: 40px;
  }

  @media screen and (max-width: 959px) {
    .teams >>> .team-players-table {
      padding-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/teams/teamForm.vue